<template>
  <div class="grid w-full grid-cols-2 gap-x-2">
    <div class="flex flex-col gap-2">
      <h3 class="text-base font-bold capitalize-first">
        {{ $t('global.group') }}
      </h3>
      <div class="flex flex-row flex-wrap gap-2">
        <BaseButton
          v-for="item in groupByElements"
          :key="item.label"
          :title="item.label"
          :icon="item.icon"
          size="small"
          :is-outline="item.value !== groupBy"
          inverse-icon-order
          @click="groupBy = item.value"
        />
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <h3 class="text-base font-bold capitalize-first">
        {{ $t('global.sort') }}
      </h3>
      <div class="flex flex-row flex-wrap gap-2">
        <BaseButton
          v-for="item in sortElements"
          :key="item.label"
          :title="item.label"
          :icon="item.icon[1]"
          :icon-type="item.icon[0]"
          size="small"
          :is-outline="item.value !== direction"
          inverse-icon-order
          @click="direction = item.value"
        />
      </div>
    </div>
  </div>
  <div class="mt-6 flex justify-end">
    <BaseButton
      :title="$t('button.close')"
      size="small"
      @click="$emit('close-popover')"
    />
  </div>
</template>

<script>
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'DisplayOptionsContent',
  components: {
    BaseButton
  },
  props: {
    sorting: {
      type: Object,
      required: true
    }
  },
  emits: ['update:sorting', 'close-popover'],
  data() {
    return {
      groupByElements: [
        {
          label: this.$t('attributes.date'),
          icon: 'calendar',
          gate: true,
          value: 'date'
        },
        {
          label: this.$t('attributes.deceased'),
          icon: 'user',
          gate: true,
          value: 'deceased'
        }
      ],
      sortElements: [
        {
          label: this.$t('global.asc'),
          icon: ['far', 'arrow-down-a-z'],
          gate: true,
          value: 'asc'
        },
        {
          label: this.$t('global.desc'),
          icon: ['far', 'arrow-down-z-a'],
          gate: true,
          value: 'desc'
        }
      ]
    }
  },
  computed: {
    groupBy: {
      get() {
        return this.sorting.group
      },
      set(value) {
        this.$emit('update:sorting', { ...this.sorting, group: value })
      }
    },
    direction: {
      get() {
        return this.sorting.direction
      },
      set(value) {
        this.$emit('update:sorting', { ...this.sorting, direction: value })
      }
    }
  }
}
</script>
